import * as z from "zod";
import { defaultCreatorGrants } from "../rbac/roles";
import { insertGrantsDeduped } from "../rbac/validation";
import { destinationSchema } from "./egressRouteShared";
import { mutator } from "./mutator";
import { generateId } from "./utils";

const MAX_CERT_PEM_BYTES = 4096;

export const createNetworkSchema = z.object({
  id: z.string(),
  name: z.string().min(1),
  identifier: z.literal("tunnel"),
  destinations: z.array(destinationSchema).min(1),
  clientCertPem: z.string().min(1).max(MAX_CERT_PEM_BYTES),
  clientCertSha256: z.string().regex(/^[0-9a-f]{64}$/),
});

export const createNetwork = mutator({
  schema: createNetworkSchema,
  resolve: {},
  permissions: [
    { permission: "tenant:network_create", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { id, name, identifier, destinations } }) => {
    const createdAt = Date.now();
    await tx.mutate.networks.insert({
      id,
      name,
      identifier,
      configuration: {},
      destinations,
      metadata: {},
      createdAt,
      createdByUserId: ctx.userId,
      lastTestAt: null,
      lastTestStatus: null,
      lastTestMessage: null,
      disabledAt: null,
      enforced: false,
      tenantId: ctx.tenantId,
    });
    for (const destination of destinations) {
      await tx.mutate.egressRoutes.insert({
        id: generateId(),
        networkId: id,
        destinationType: destination.type,
        destination:
          destination.type === "cidr" ? destination.range : destination.pattern,
        enforced: false,
        createdAt,
        disabledAt: null,
        tenantId: ctx.tenantId,
      });
    }
    await insertGrantsDeduped(
      tx,
      defaultCreatorGrants("network", { userId: ctx.userId }),
      id,
      ctx.tenantId
    );
  },
});
